export default __webpack_public_path__ + "static/media/mystery-box.fc43f601.mp4";